/**
 * Service de tracking universel
 * Compatible Umami, Google Analytics 4 et Microsoft Clarity
 *
 * UTILISATION :
 * - Umami     : fonctionne automatiquement via le script dans index.html (pas de code JS requis)
 * - GA4       : décommentez la section GA4 ci-dessous et installez react-ga4
 * - Clarity   : fonctionne automatiquement via le script dans index.html
 */

// ─── Google Analytics 4 ───────────────────────────────────────────────────────
// Pour activer GA4 :
// 1. npm install react-ga4
// 2. Décommentez les lignes ci-dessous et remplacez G-XXXXXXXXXX

// import ReactGA from 'react-ga4';
// const GA4_ID = 'G-XXXXXXXXXX';
// ReactGA.initialize(GA4_ID);

// ─── Helpers universels ──────────────────────────────────────────────────────

/**
 * Suit un changement de page (appeler dans chaque route)
 * Compatible Umami (auto) + GA4
 */
export function trackPageView(url, title) {
  // GA4
  if (typeof window.gtag === 'function') {
    window.gtag('config', window.GA4_ID, { page_path: url, page_title: title });
  }
  // Umami (méthode manuelle si besoin)
  if (typeof window.umami === 'object' && window.umami.track) {
    window.umami.track({ website: window.UMAMI_WEBSITE_ID, url, title });
  }
}

/**
 * Suit un événement personnalisé
 * @param {string} eventName  - ex: 'tableau_view', 'contact_click'
 * @param {object} data       - données additionnelles
 */
export function trackEvent(eventName, data = {}) {
  // GA4
  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, data);
  }
  // Umami
  if (typeof window.umami === 'object' && window.umami.track) {
    window.umami.track(eventName, data);
  }
  // Microsoft Clarity
  if (typeof window.clarity === 'function') {
    window.clarity('set', eventName, JSON.stringify(data));
  }
}

/**
 * Suit la vue d'un tableau (œuvre d'art)
 * @param {object} tableau - { id, titre, categorie, prix }
 */
export function trackTableauView(tableau) {
  trackEvent('tableau_view', {
    tableau_id: tableau.id,
    tableau_titre: tableau.titre || tableau.title,
    categorie: tableau.categorie || tableau.category,
    prix: tableau.prix || tableau.price,
  });
}

/**
 * Suit un clic sur "Contacter l'artiste"
 * @param {object} tableau - { id, titre }
 */
export function trackContactIntent(tableau) {
  trackEvent('contact_intent', {
    tableau_id: tableau?.id,
    tableau_titre: tableau?.titre || tableau?.title,
    source: 'tableau_detail',
  });
}

/**
 * Suit l'envoi du formulaire de contact
 */
export function trackContactFormSubmit() {
  trackEvent('contact_form_submit', { source: 'contact_page' });
}

